import { render, staticRenderFns } from "./manyStore.vue?vue&type=template&id=3dcebda4&scoped=true&"
import script from "./manyStore.vue?vue&type=script&lang=js&"
export * from "./manyStore.vue?vue&type=script&lang=js&"
import style0 from "./manyStore.vue?vue&type=style&index=0&id=3dcebda4&lang=scss&scoped=true&"
import style1 from "./manyStore.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcebda4",
  null
  
)

export default component.exports